import classNames from 'classnames';

import type { VFC, ReactElement } from 'react';

import * as styles from './Circle.module.scss';

type Props = {
  className?: string;
  children: ReactElement | string;
};

export const Circle: VFC<Props> = (props) => {
  const { className, children } = props;

  return <div className={classNames(styles.circle, className)}>{children}</div>;
};
